import { useState, useEffect, useRef } from "react";
import { getLetterheads, uploadLetterhead, deleteLetterhead } from "../../mailerApi";
import "./Mailer.css";

function formatDate(s) {
  if (!s) return "";
  try { return new Date(s).toLocaleDateString("ka-GE"); }
  catch { return ""; }
}

export default function LetterheadsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const d = await getLetterheads();
      setItems(Array.isArray(d) ? d : (d.results || []));
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }

  async function handleUpload(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError("");
    try {
      const item = await uploadLetterhead(file, file.name);
      setItems(prev => [item, ...prev]);
    } catch (err) {
      setError(err.message);
    }
    setUploading(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }

  async function handleDelete(item) {
    if (!window.confirm(`წავშალო "${item.name}"?`)) return;
    try {
      await deleteLetterhead(item.id);
      setItems(prev => prev.filter(i => i.id !== item.id));
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="mailer-page library-page">
      <div className="mailer-header">
        <h1>ტიტულარები</h1>
        <div className="library-toolbar">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/png,image/jpeg,image/gif"
            style={{ display: "none" }}
            onChange={handleUpload}
          />
          <button
            className="btn btn-primary"
            onClick={() => fileInputRef.current?.click()}
            disabled={uploading}
          >
            {uploading ? "იტვირთება..." : "+ ტიტულარის ატვირთვა"}
          </button>
        </div>
      </div>

      {error && <div className="mailer-error">{error}<button onClick={() => setError("")}>×</button></div>}

      {loading ? (
        <div className="library-empty">იტვირთება...</div>
      ) : items.length === 0 ? (
        <div className="library-empty">
          ტიტულარების ბიბლიოთეკა ცარიელია — ატვირთე სურათი (PNG/JPG), შემდეგ მონიშნე გაგზავნისას.
        </div>
      ) : (
        <div className="library-grid letterhead-grid">
          {items.map(item => (
            <div key={item.id} className="library-card letterhead-card">
              {item.image_url && (
                <div className="letterhead-thumb">
                  <img src={item.image_url} alt={item.name} />
                </div>
              )}
              <div className="library-card-name" title={item.name}>{item.name}</div>
              <div className="library-card-meta">{formatDate(item.created_at)}</div>
              <div className="library-card-actions">
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item)}>
                  წაშლა
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
